import { Box, Container, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

import Page from "../elements/Page";

const Privacy = () => {
  return (
    <>
      <Page title="클릭리스 DTx B 개인정보처리방침">
        <Container sx={{ pb: 5 }}>
          <Box sx={{ my: 5 }} display="flex">
            <Typography variant="h4">클릭리스 DTx B 개인정보처리방침</Typography>
          </Box>

          <ReactMarkdown
              components={{
                  h1: ({children}) => <Typography variant="h1">{children}</Typography>,
                  h2: ({children}) => <Typography variant="h2">{children}</Typography>,
                  h3: ({children}) => <Typography variant="h3">{children}</Typography>,
                  h4: ({children}) => <Typography variant="h4" sx={{ mx: 1, my: 3 }}>{children}</Typography>,
                  h5: ({children}) => <Typography variant="h5" sx={{ mx: 2, my: 2 }}>{children}</Typography>,
                  h6: ({children}) => <Typography variant="h6" sx={{ mx: 3, my: 1 }}>{children}</Typography>,
                  p: ({children}) => <Typography variant="p" sx={{ mx: 3 }}>{children}</Typography>,
                  ul: ({children}) => <ul style={{padding: "0 20px"}}>{children}</ul>,
              }}
              remarkPlugins={[remarkBreaks, remarkGfm]}>{`
#### 개인정보 처리방침
주식회사 비욘드메디슨(이하 비욘드메디슨)은 정보주체의 자유와 권리 보호를 위해 개인정보 보호법 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 이에 개인정보 보호법에 따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.

#### 1. 처리하는 개인정보 항목
비욘드메디슨은 다음의 개인정보 항목을 처리하고 있습니다.

##### 회원가입
- 이메일, 비밀번호, 이름, 성별, 생년월일

##### 서비스 이용 과정에서 이용자로부터 수집하는 개인정보
- 단말기 및 애플리케이션 정보
  - 단말기 정보 (단말기 모델, OS 종류 및 버전)
  - 애플리케이션 내 각종 사용 기록(화면/메뉴 진입, 버튼 선택과 같은 애플리케이션 내 기능 사용, 사용 중 발생하는 오류)
  - 이용자가 작성한 게시글 등 이용자 활동 정보
  - 앱 버전, 마지막 로그인 일시

##### 민감정보 (건강정보)
- 검사 내용 및 결과
  - 턱관절 사용제한 검사(JFLS-8), 턱관절 행동 검사(OBC), 일반 스트레스 검사(PHQ-4)
- 각 정보의 생성 시각

##### 고객 문의 시
- 이메일 및 고객문의 내용

#### 2. 개인정보의 처리 목적
비욘드메디슨은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

##### 회원 관리 및 본인 확인
- 사용자 식별, 회원 가입/탈퇴 의사 확인, 연령(만 14세 이상) 확인, 사용자 본인 확인
- 서비스 부정 이용 등 방지, 민원 등 사용자의 요청사항 처리
- 공지사항 등 전달

##### 서비스 제공

##### 서비스 개선 및 개발
고객만족 조사, 서비스 방문 및 이용에 대한 분석 및 통계, 기존 서비스 개선, 신규 서비스 기획·연구·개발

##### 고객문의 응대
문의 접수 및 답변 제공, 문의 내역 관리

#### 3. 개인정보의 처리 및 보유 기간
회원가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우 고객센터를 통한 상담 과정에서 이용자의 개인정보가 수집될 수 있습니다.
기기정보와 같은 생성정보는 앱 이용 과정에서 자동으로 생성되어 수집될 수 있습니다.
비욘드메디슨은 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
- 홈페이지 회원 가입 및 관리, 서비스 제공, 서비스 개선 및 개발: 회원탈퇴 시까지

상기 보유 기간과 별도로 법령에 따라 보존하여야 하는 경우는 다음과 같습니다.
- 전자상거래 등에서 소비자 보호에 관한 법률
  - 계약 또는 청약철회 등에 관한 기록: 5년
  - 대금결제 및 재화 등의 공급에 관한 기록: 5년
  - 소비자의 불만 또는 분쟁처리에 관한 기록: 3년
- 통신비밀보호법
  - 인터넷의 로그기록자료: 3개월
- 의료기기법 (별도 동의서를 통해 임상시험에 동의한 임상시험 대상자에 한하여 적용됩니다.)
  - 제조허가ㆍ수입허가 또는 그 변경허가를 위한 임상시험 관련 자료: 허가일부터 3년
  - 그 밖의 임상시험 관련 자료: 임상시험이 완료된 날부터 3년

#### 4. 개인정보의 파기절차 및 파기방법
비욘드메디슨은 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.
개인정보 파기의 절차 및 방법은 다음과 같습니다.

##### 파기절차
파기 사유가 발생하면 개인정보는 바로 삭제됩니다. 법령에 따라 계속 보존하여야 하는 경우에는 개인정보를 별도의 데이터베이스에 옮겨서 법령이 정한 기간 동안 보관하며, 기간이 지나면 바로 삭제합니다.

##### 파기방법
비욘드메디슨은 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.

#### 5. 개인정보의 제3자 제공에 관한 사항
비욘드메디슨은 정보주체의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다.

##### 임상시험
비욘드메디슨은 임상시험에 참여자에게 동의를 얻은 후 다음과 같이 제3자에게 제공합니다.
- 임상시험 실시기관
  - 한림대학교성심병원
  - 한림대학교동탄성심병원
- 제공목적
  - 임상시험의 실시
- 제공항목
  - 검사 내용 및 결과
    - 턱관절 행동 검사(OBC), 일반 스트레스 검사(PHQ-4)
  - 프로그램 참여 일수
- 보유 및 이용 기간
  - 제조허가ㆍ수입허가 또는 그 변경허가를 위한 임상시험 관련 자료: 허가일부터 3년
  - 그 밖의 임상시험 관련 자료: 임상시험이 완료된 날부터 3년

비욘드메디슨은 다음과 같이 재난, 감영병, 급박한 생명·신체 위험을 초래하는 사건·사고, 급박한 재산 손실 등의 긴급상황이 발생하는 경우 정보주체의 동의 없이 관계기관에 개인정보를 제공할 수 있습니다.

#### 6. 개인정보처리의 위탁에 관한 사항
비욘드메디슨은 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.

##### Amazon Web Services Korea LLC
- 위탁내용
  - 클라우드 환경 제공 (클라우드 서버의 운영 및 관리), 회원가입
  - 서비스 탈퇴 등 개인정보 수집 및 이용목적 달성 시까지

##### CRS Insight
- 위탁 내용
  - 임상시험 위탁 수행
- 보유 기간
  - 제조허가ㆍ수입허가 또는 그 변경허가를 위한 임상시험 관련 자료: 허가일부터 3년
  - 그 밖의 임상시험 관련 자료: 임상시험이 완료된 날부터 3년

비욘드메디슨은 위탁계약 체결 시 개인정보 보호법에 따라 위탁업무 수행목적 외 개인정보 처리 금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.

#### 7. 가명정보의 처리 등에 관한 사항
주식회사 비욘드메디슨은 수집한 개인정보를 특정 개인을 알아볼 수 없도록 가명처리하여 통계 작성, 과학적 연구, 공익적 기록 보존 등을 위하여 처리할 수 있습니다. 가명정보를 이용할 경우 가명정보의 안전성 확보조치로서 관리적 조치 및 기술적 조치를 취합니다.

#### 8. 정보주체의 권리ㆍ의무 및 그 행사방법에 관한 사항
이용자는 자신의 개인정보 처리에 관하여 아래와 같은 권리를 가질 수 있습니다.
- 개인정보 열람 및 전송을 요구할 권리
- 개인정보 처리 정지, 정정ㆍ삭제를 요구할 권리

이용자는 서비스 내 다음과 같은 기능을 통해 언제든지 개인정보 열람 등의 권리를 직접 행사하거나 또는 고객센터를 통해 요청할 수 있습니다.
- 애플리케이션 내 정보에서 개인정보 열람 및 수정
- 고객센터 문의하기
- 회원탈퇴를 통한 개인정보 수집 및 이용 동의 철회

비욘드메디슨은 이용자가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 해당 개인정보를 이용 또는 제공하지 않습니다.
정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.
- 개인정보분쟁조정위원회: (국번없이) 1833-6972 (www.kopico.go.kr)
- 개인정보침해신고센터: (국번없이) 118 (privacy.kisa.or.kr)
- 대검찰청: (국번없이) 1301 (spo.go.kr)
- 경찰청: (국번없이) 182 (ecrm.cyber.go.kr)

#### 9. 보호책임자의 성명과 전화번호 등 연락처
비욘드메디슨은 정보주체의 개인정보자기결정권을 보장하고, 개인정보 침해로 인한 문의및 피해 구제를 위해 노력하고 있으며, 신고 또는 문의가 필요한 경우 아래의 연락처로 연락해 주시기 바랍니다.
- 개인정보 보호책임자: 김대현 (대표이사)
- 연락처: 070-8095-5066
- 메일: support@beyondmedicine.kr

#### 10. 개인정보를 자동으로 수집하는 장치
비욘드메디슨은 이용 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용하지 않습니다.

#### 11. 제30조에 따른 개인정보의 안전성 확보 조치에 관한 사항
비욘드메디슨은 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
- 관리적 조치: 내부관리계획 수립·시행, 개인정보 교육 실시
- 기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 개인정보의 암호화, 보안프로그램 설치 및 갱신

#### 12. 개인정보 처리방침 업데이트
개인정보 처리방침은 처리하는 개인정보 내용 등 변경사항이 있으면, 이를 반영하여 언제든지 업데이트될 수 있습니다. 개인정보 처리방침이 업데이트될 경우, 시행되기 최소 7일 전에 공지사항 등을 통해 미리 알려드립니다.
- 개인정보 처리방침 버전: V0
- 개인정보 처리방침 시행 일자: 2024년 3월 3일
`}</ReactMarkdown>
        </Container>
      </Page>
    </>
  );
};

export default Privacy;
